import { VueRenderer } from '@tiptap/vue-3'
import tippy from 'tippy.js'
import store from '@/store';
import MentionList from '@/components/MentionsList/index.vue'

export default {
  items: async ({ query }) => {
    if(query !== '') {
      const payload = {
        query: query,
        limit: 10,
        autocomplete: true
      }
      let usersData = await store.dispatch("fetchUsers", payload);
      let users = usersData.results.map(item => {
        return `${item.lastName} ${item.firstName}`
      })
      return usersData.results;
    } else {
      return [''];
    }
  },

  render: () => {
    let component
    let popup

    return {
      onStart: props => {
        component = new VueRenderer(MentionList, {
          props,
          editor: props.editor,
        })

        if (!props.clientRect) {
          return
        }

        popup = tippy('body', {
          getReferenceClientRect: props.clientRect,
          appendTo: () => document.body,
          content: component.element,
          showOnCreate: true,
          interactive: true,
          trigger: 'manual',
          placement: 'bottom-start',
        })
      },

      onUpdate(props) {
        component.updateProps(props)

        if (!props.clientRect) {
          return
        }

        popup[0].setProps({
          getReferenceClientRect: props.clientRect,
        })
      },

      onKeyDown(props) {
        if (props.event.key === 'Escape') {
          popup[0].hide()

          return true
        }

        return component.ref?.onKeyDown(props)
      },

      onExit() {
        popup[0].destroy()
        component.destroy()
      },
    }
  },
}